import React from 'react';
import { Box, Typography, Grid, Container, Card, CardContent } from '@mui/material';
import ServiceTable from '../components/ServiceTable';
import AnimatedSection from '../components/AnimatedSection';
const menHeroImg = '/assets/men.jpeg';

const sections = [
  {
    title: 'Hair Cuts',
    rows: [
      { service: 'Beard Shave', price: '₹200' },
      { service: 'Hair Wash & Blow Dry', price: '₹500' },
      { service: 'Kids Hair Style', price: '₹350' },
      { service: 'Senior Stylist', price: '₹300' },
      { service: 'Top Stylist', price: '₹500' },
      { service: 'Styling', price: '₹600' },
      { service: 'Creative Hair Cut', price: '₹600' },
    ],
  },
  {
    title: 'Hair Colours',
    rows: [
      { service: 'Mustache', price: '₹200' },
      { service: 'Streaks (per streak)', price: '₹300' },
      { service: 'Beard', price: '₹500' },
      { service: 'Highlights', price: '₹1,000 onwards' },
      { service: 'Root Touch Up', price: '₹1,000 onwards' },
      { service: 'Global Highlights', price: '₹2,000 onwards' },
      { service: 'Global Hair Colour', price: '₹2,000 onwards' },
    ],
  },
  {
    title: 'Straightening & Smoothening',
    rows: [
      { service: 'Straightening', price: '₹3,000 onwards' },
      { service: 'Smoothening', price: '₹3,500 onwards' },
    ],
  },
  {
    title: 'Hair Spa',
    rows: [
      { service: 'Short Length - 30 Min', price: '₹1,000' },
      { service: 'Short Length - 60 Min', price: '₹1,500' },
      { service: 'Medium Length - 30 Min', price: '₹1,500' },
      { service: 'Medium Length - 60 Min', price: '₹2,000' },
      { service: 'Extra Length - 30 Min', price: '₹1,500' },
      { service: 'Extra Length - 60 Min', price: '₹2,000' },
    ],
  },
  {
    title: 'Relax & Refresh',
    rows: [
      { service: 'Head Massage (20 Min)', price: '₹800' },
      { service: 'Foot Massage (20 Min)', price: '₹1,000' },
      { service: 'Shoulder & Back Massage (20 Min)', price: '₹1,500' },
    ],
  },
  {
    title: 'Full Body Massage',
    rows: [
      { service: '30 Min', price: '₹2,000' },
      { service: '45 Min', price: '₹3,000' },
      { service: '60 Min', price: '₹4,000' },
    ],
  },
  {
    title: 'Hair Treatments',
    rows: [
      { service: 'Dandruff', price: '₹2,500' },
      { service: 'Hair Fall', price: '₹3,000' },
      { service: 'Loreal Aminexil', price: '₹2,500' },
      { service: 'Fibre Clinix', price: '₹2,500' },
      { service: 'Scalp Genesis', price: '₹3,000' },
      { service: 'Pro Longer', price: '₹3,000' },
      { service: 'Root Activating', price: '₹3,500' },
    ],
  },
  {
    title: 'Waxing',
    rows: [
      { service: 'Fore Head', price: '₹100' },
      { service: 'Cheeks', price: '₹200' },
      { service: 'Under Arms', price: '₹500' },
      { service: 'Full Hands', price: '₹1,000' },
      { service: 'Full Front (chest)', price: '₹1,500' },
      { service: 'Full Legs', price: '₹1,500' },
      { service: 'Full Back', price: '₹2,000' },
      { service: 'Full Body', price: '₹5,000' },
    ],
  },
  {
    title: 'Keratin Treatments',
    rows: [
      { service: 'Keratin', price: '₹2,500 onwards' },
    ],
  },
  {
    title: 'Clean Up',
    rows: [
      { service: 'Basic Clean Up', price: '₹800' },
      { service: 'Acne Clean Up', price: '₹1,000' },
      { service: 'Whitening Clean Up', price: '₹1,500' },
    ],
  },
  {
    title: 'Basic Facials',
    rows: [
      { service: 'Fruit Facial', price: '₹1,000' },
      { service: 'Chocolate Facial', price: '₹1,200' },
      { service: 'Tan Clear', price: '₹2,000' },
      { service: 'Brightup Facial', price: '₹2,300' },
      { service: 'Oxy Glow Facial', price: '₹2,500' },
      { service: 'Anti Ageing Facial', price: '₹2,800' },
      { service: 'Skin Miracle', price: '₹3,000' },
    ],
  },
  {
    title: 'Metallic Facials',
    rows: [
      { service: 'Pearl', price: '₹2,500' },
      { service: 'Gold', price: '₹3,000' },
      { service: 'Diamond', price: '₹3,500' },
      { service: '24K Carat Gold Facial', price: '₹4,000' },
    ],
  },
  {
    title: 'Luxury Facials',
    rows: [
      { service: 'Insta Fair', price: '₹3,000' },
      { service: 'Sensi Glow Facial', price: '₹3,000' },
      { service: 'Snow White', price: '₹3,500' },
      { service: 'Oxygen Facial', price: '₹3,500' },
      { service: 'Ultra Bright Facial', price: '₹3,500' },
      { service: 'Hydra Boost', price: '₹3,500' },
      { service: '4 Layer', price: '₹4,000' },
      { service: 'Fair For Sure Facial', price: '₹4,000' },
      { service: 'Party Facial', price: '₹4,000' },
      { service: 'O3 Facial', price: '₹5,000' },
      { service: 'Jewel Facial', price: '₹5,000' },
      { service: 'Bridal Glow Facial', price: '₹6,000' },
      { service: 'Splash Signature Facial', price: '₹8,000' },
    ],
  },
  {
    title: 'Pedicure',
    rows: [
      { service: 'Quick Pedicure', price: '₹700' },
      { service: 'Rose Pedicure', price: '₹800' },
      { service: 'Fruit Punch', price: '₹1,000' },
      { service: 'Chocolate Pedicure', price: '₹1,200' },
      { service: 'Foot Spa Pedicure', price: '₹1,500' },
      { service: 'Tata Tan Pedicure', price: '₹2,000' },
      { service: 'Crystal Pedicure', price: '₹2,500' },
      { service: 'Bomb Pedicure', price: '₹3,000' },
      { service: 'Peel Off Pedicure', price: '₹3,500' },
    ],
  },
  {
    title: 'Manicure',
    rows: [
      { service: 'Express Manicure', price: '₹500' },
      { service: 'Rose Manicure', price: '₹600' },
      { service: 'Fruit Manicure', price: '₹800' },
      { service: 'Chocolate Manicure', price: '₹1,000' },
      { service: 'Hand Spa Manicure', price: '₹1,200' },
      { service: 'Tata Tan Manicure', price: '₹1,500' },
      { service: 'Crystal Manicure', price: '₹2,000' },
      { service: 'Ice Cream Manicure', price: '₹2,500' },
      { service: 'Peel Off Manicure', price: '₹3,000' },
    ],
  },
  {
    title: 'Treatment',
    rows: [
      { service: 'Heel Peel', price: '₹3,500' },
    ],
  },
];

const packages = [
  {
    name: 'Gold Package',
    price: '₹4,999',
    items: [
      '• Pearl Facial',
      '• Face & Neck De-Tan',
      '• Glow Pedicure',
      '• Glow Manicure',
      '• Repair Hair Spa',
      '• Hair Cut',
      '• Beard Shaping',
    ],
    featured: false,
  },
  {
    name: 'Premium Package',
    price: '₹6,999',
    items: [
      '• Fair for Sure',
      '• Face & Neck De-Tan',
      '• Crystal Spa Pedicure',
      '• Crystal Spa Manicure',
      '• Full Body Crystal Scrub',
      '• Classic Hair Spa',
      '• Hair Cut',
      '• Beard Shaping',
    ],
    featured: true,
  },
  {
    name: 'Platinum Package',
    price: '₹8,999',
    items: [
      '• Splash Signature Facial',
      '• Face & Neck De-Tan',
      '• Bomb Pedicure',
      '• Ice Cream Manicure',
      '• Full Body Diamond De-Tan',
      '• Five Step Body Polishing',
      '• Conditioning Hair Spa',
      '• Hair Cut',
      '• Beard Shaping',
    ],
    featured: false,
  },
];

export default function MenPage() {
  return (
    <Box>
      {/* Hero */}
      <Box
        sx={{
          position: 'relative',
          backgroundImage: `url(${menHeroImg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          py: { xs: 8, md: 12 },
          textAlign: 'center',
          color: '#fff',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
          },
        }}
      >
        <Box sx={{ position: 'relative', zIndex: 1 }}>
          <Typography
            variant="h2"
            sx={{
              color: '#fff',
              fontFamily: '"Playfair Display", serif',
              fontSize: { xs: '2.5rem', md: '3.5rem' },
              mb: 1.5,
              textShadow: '0 2px 10px rgba(0,0,0,0.4)',
            }}
          >
            Men's Menu
          </Typography>
          <Typography
            sx={{
              fontFamily: '"Lato", sans-serif',
              color: 'rgba(255,255,255,0.9)',
              fontSize: '1.1rem',
              maxWidth: '600px',
              mx: 'auto',
              px: 2,
            }}
          >
            Premium grooming services tailored for the modern gentleman
          </Typography>
        </Box>
      </Box>

      {/* Services */}
      <Container maxWidth="lg" sx={{ py: 7 }}>
        <Grid container spacing={4}>
          {sections.map((section, i) => (
            <Grid item xs={12} md={6} key={section.title}>
              <AnimatedSection delay={(i % 4) * 0.1}>
                <Box sx={{ mb: 1 }}>
                  <Typography
                    variant="h5"
                    sx={{
                      fontFamily: '"Playfair Display", serif',
                      color: '#FF0099',
                      mb: 1.5,
                      fontSize: '1.2rem',
                    }}
                  >
                    {section.title}
                  </Typography>
                  <ServiceTable rows={section.rows} />
                </Box>
              </AnimatedSection>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Packages */}
      <Box sx={{ backgroundColor: '#fafafa', py: 7 }}>
        <Container maxWidth="lg">
          <AnimatedSection>
            <Typography
              variant="h4"
              sx={{
                fontFamily: '"Playfair Display", serif',
                color: '#1a1a1a',
                textAlign: 'center',
                mb: 5,
                fontSize: { xs: '1.5rem', md: '2rem' },
              }}
            >
              Men's Packages
            </Typography>
          </AnimatedSection>
          <Grid container spacing={3} justifyContent="center">
            {packages.map((pkg, i) => (
              <Grid item xs={12} sm={6} md={4} key={pkg.name}>
                <AnimatedSection delay={i * 0.15}>
                  <Card
                    elevation={pkg.featured ? 8 : 1}
                    sx={{
                      borderRadius: 3,
                      overflow: 'hidden',
                      border: pkg.featured ? '2px solid #FF0099' : '1px solid #eee',
                      backgroundColor: pkg.featured ? '#FF0099' : '#fff',
                      transition: 'transform 0.3s',
                      '&:hover': { transform: 'translateY(-4px)' },
                    }}
                  >
                    <CardContent sx={{ p: 3 }}>
                      <Typography
                        sx={{
                          fontFamily: '"Playfair Display", serif',
                          fontSize: '1.1rem',
                          fontWeight: 700,
                          color: pkg.featured ? '#fff' : '#1a1a1a',
                          mb: 0.5,
                        }}
                      >
                        {pkg.name}
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: '"Playfair Display", serif',
                          fontSize: '2rem',
                          fontWeight: 800,
                          color: pkg.featured ? '#fff' : '#FF0099',
                          mb: 2,
                        }}
                      >
                        {pkg.price}
                      </Typography>
                      {pkg.items.map((item, j) => (
                        <Typography
                          key={j}
                          sx={{
                            fontFamily: '"Lato", sans-serif',
                            fontSize: '0.82rem',
                            color: pkg.featured ? 'rgba(255,255,255,0.9)' : '#555',
                            mb: 0.4,
                            lineHeight: 1.6,
                          }}
                        >
                          {item}
                        </Typography>
                      ))}
                    </CardContent>
                  </Card>
                </AnimatedSection>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </Box>
  );
}